import { render } from "./asset-menu.vue?vue&type=template&id=0ca5ae24"
import script from "./asset-menu.vue?vue&type=script&lang=js"
export * from "./asset-menu.vue?vue&type=script&lang=js"
script.render = render

export default script